import { styled } from "@mui/material/styles";
import React from "react";
import { Markdown } from "../Markdown";
const UserBubble = styled("div")({
    alignSelf: "flex-end",
    maxWidth: "84%",
    padding: "var(--j-sp-2) var(--j-sp-3)",
    borderRadius: "var(--j-r-md)",
    background: "var(--j-panel)",
    border: "1px solid var(--j-line-soft)",
    fontSize: "var(--j-fs-md)",
    lineHeight: "var(--j-lh-lg)",
    whiteSpace: "pre-wrap",
    overflowWrap: "anywhere"
});
export function TextPart({ part, ctx }) {
    if (ctx.message.role === "user") return /*#__PURE__*/ React.createElement(UserBubble, null, part.text);
    return /*#__PURE__*/ React.createElement(Markdown, null, part.text);
}
